import { Injectable } from '@angular/core';

declare let hj: any;

@Injectable({
  providedIn: 'root'
})
export class HotjarService {
  constructor() {}

  identifyUser(userId: string, userAttributes: any): void {
    if (typeof hj !== 'undefined') {
      hj('identify', userId, userAttributes);
    }
  }
}
